import { FC } from 'react';
import { useToast, Toast, ToastVariant } from '@/context/ToastContext.tsx';
import { cn } from '@/utils/classNames.ts';
import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

const variantConfig: Record<ToastVariant, { className: string; Icon: FC<{ className?: string }> }> = {
  success: {
    className: 'alert-success',
    Icon: CheckCircleIcon,
  },
  error: {
    className: 'alert-error',
    Icon: ExclamationCircleIcon,
  },
  info: {
    className: 'alert-info',
    Icon: InformationCircleIcon,
  },
};

const ToastItem: FC<{ toast: Toast; onRemove: (id: string) => void }> = ({ toast, onRemove }) => {
  const { className, Icon } = variantConfig[toast.variant];

  return (
    <div role="alert" className={cn('alert shadow-lg flex items-center gap-3 min-w-72 max-w-sm', className)}>
      <Icon className="w-5 h-5 shrink-0" />
      <span className="text-sm flex-1 whitespace-pre-line">{toast.message}</span>
      <button onClick={() => onRemove(toast.id)} className="btn btn-ghost btn-xs btn-circle">
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  );
};

const ToastList: FC = () => {
  const { toasts, removeToast } = useToast();

  if (!toasts.length) return null;

  return (
    <div className="toast toast-end toast-top z-50">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onRemove={removeToast} />
      ))}
    </div>
  );
};

export default ToastList;
